import React, { useEffect, useState } from 'react';
import { db, auth } from '../Services/Firebase/firebaseConfigOuvidoria';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { Box, Typography, CircularProgress, Button, Card, CardContent, Chip } from '@mui/material';
import { onAuthStateChanged } from 'firebase/auth';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const NAVY = '#011838';
const BLUE = '#003E87';

const Config = () => {
    const [configuracao, setConfiguracao] = useState(null);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (u) => setUser(u));
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (user) fetchConfiguracao();
    }, [user]);

    const fetchConfiguracao = async () => {
        setLoading(true);
        try {
            const docRef = doc(db, 'configuracoes', 'suaConfiguracao');
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setConfiguracao(docSnap.data());
            } else {
                await setDoc(docRef, { tipo: 'registro', registrarEnabled: true });
                fetchConfiguracao();
            }
        } catch (error) {
            console.error('Erro ao buscar configuração:', error);
        } finally {
            setLoading(false);
        }
    };

    const toggleConfiguracao = async () => {
        if (configuracao) {
            const updated = !configuracao.registrarEnabled;
            await updateDoc(doc(db, 'configuracoes', 'suaConfiguracao'), { registrarEnabled: updated });
            setConfiguracao(prev => ({ ...prev, registrarEnabled: updated }));
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                <CircularProgress sx={{ color: BLUE }} />
            </Box>
        );
    }

    const isEnabled = configuracao?.registrarEnabled;

    return (
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ color: NAVY, fontWeight: 700, letterSpacing: 0.3 }}>
                    Configurações
                </Typography>
                <Typography variant="body2" sx={{ color: '#888', mt: 0.5, fontSize: 13 }}>
                    Gerenciamento do sistema de ouvidoria
                </Typography>
            </Box>

            {configuracao ? (
                <Card
                    elevation={0}
                    sx={{
                        border: '1px solid #e8eaf0',
                        borderRadius: 2,
                        borderTop: `4px solid ${BLUE}`,
                        maxWidth: 500,
                    }}
                >
                    <CardContent sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 3 }}>
                            <Box
                                sx={{
                                    width: 44,
                                    height: 44,
                                    borderRadius: 2,
                                    bgcolor: 'rgba(0,62,135,0.08)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                }}
                            >
                                <PersonAddIcon sx={{ color: BLUE, fontSize: 24 }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" sx={{ color: NAVY, fontWeight: 700, lineHeight: 1.3 }}>
                                    Tela de Registro de Usuários
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#888', fontSize: 12, mt: 0.5 }}>
                                    Controla o acesso à página de criação de novas contas no sistema
                                </Typography>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                mb: 3,
                                p: 1.5,
                                bgcolor: '#f8f9fb',
                                borderRadius: 1.5,
                            }}
                        >
                            <Typography variant="body2" sx={{ color: '#666', fontSize: 13 }}>
                                Status atual:
                            </Typography>
                            <Chip
                                label={isEnabled ? 'Ativo' : 'Inativo'}
                                size="small"
                                sx={{
                                    bgcolor: isEnabled ? '#E8F5E9' : '#FFF3E0',
                                    color: isEnabled ? '#2E7D32' : '#E65100',
                                    fontWeight: 700,
                                    fontSize: 12,
                                    border: `1px solid ${isEnabled ? '#A5D6A7' : '#FFCC80'}`,
                                    height: 24,
                                }}
                            />
                        </Box>

                        <Button
                            variant="contained"
                            onClick={toggleConfiguracao}
                            startIcon={isEnabled ? <ToggleOffIcon /> : <ToggleOnIcon />}
                            sx={{
                                bgcolor: isEnabled ? '#C62828' : BLUE,
                                '&:hover': { bgcolor: isEnabled ? '#B71C1C' : NAVY },
                                fontWeight: 700,
                                borderRadius: 2,
                                px: 3,
                                py: 1,
                                boxShadow: 'none',
                                textTransform: 'none',
                                fontSize: 14,
                            }}
                        >
                            {isEnabled ? 'Desativar Registro' : 'Ativar Registro'}
                        </Button>
                    </CardContent>
                </Card>
            ) : (
                <Typography sx={{ color: '#bbb' }}>Nenhuma configuração disponível.</Typography>
            )}
        </Box>
    );
};

export default Config;
